'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:waypoint-portal-app":true});}catch(e){}}();

import { useCallback } from 'react';

import { BaseAuthErrorPage, Button } from '@components';
import { localStorageKeys } from '@constants';
import { IconArrowLeft } from '@endurancewarranty/icons';
import { Flex } from '@endurancewarranty/ui';
import { useAppRouter } from '@hooks';
import { AppRouteEnum } from '@lib/enums';

import type { ReactNode } from 'react';

export default function NotFound(): ReactNode {
  const router = useAppRouter();

  const onBackToDashboardClick = useCallback(() => {
    localStorage?.removeItem(localStorageKeys.selectedContractNumber);
    router.replace(AppRouteEnum.Dashboard);
  }, [router]);

  return (
    <BaseAuthErrorPage
      isLogoVisible={false}
      title="Page Not Found"
      message="The page you are looking for doesn't exist or may have been moved. Try heading back to the dashboard."
      action={
        <Flex className="gap-4" direction="col">
          <Button onClick={onBackToDashboardClick} variant="success">
            <IconArrowLeft className="mr-2 h-4 w-4" />
            Back to Dashboard
          </Button>
        </Flex>
      }
    />
  );
}
